function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-statements */
import React, { useEffect, useState, useRef } from 'react';
import { Translate } from "../../../I18N";
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { isString } from 'lodash';
import { InputField, RadioSelect } from '.';
import { Pill } from "../UI/Pill";
import { Label } from "./Label";
import { Checkbox } from "./Checkbox";

























const renderChild = (child) =>
isString(child) ? /*#__PURE__*/_jsx(Translate, {}, void 0, child) : child;

const MultiselectList = ({
  items,
  onChange,
  className = '',
  label,
  hasErrors,
  value,
  checkboxes = false,
  foldableGroups = false,
  singleSelect = false,
  allowSelelectAll = false,
  startOnSelected = false,
  search = '',
  suggestions = false,
  blankState = /*#__PURE__*/_jsx(Translate, {}, void 0, "No items available")
}) => {
  const [selectedItems, setSelectedItems] = useState(value || []);
  const [showAll, setShowAll] = useState(!(startOnSelected && selectedItems.length));
  const [searchTerm, setSearchTerm] = useState('');
  const [externalSearch, setExternalSearch] = useState(search);
  const [filteredItems, setFilteredItems] = useState(items);
  const [openGroups, setOpenGroups] = useState([]);
  const [selectedOrSuggestedItems, setSelectedOrSuggestedItems] = useState(
    new Set(selectedItems)
  );
  const optionsRef = useRef(null);

  useEffect(() => {
    const newSet = new Set(selectedItems);
    items.forEach((item) => {
      if (item.suggested) {
        newSet.add(item.value);
      }

      if (item.items) {
        item.items.forEach((subItem) => {
          if (subItem.suggested) {
            newSet.add(subItem.value);
          }
        });
      }
    });

    setSelectedOrSuggestedItems(newSet);
  }, [items, selectedItems]);

  useEffect(() => {
    if (startOnSelected) {
      const groupsToExpand = items.
      filter((item) => {var _item$items;return (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.some((childItem) => value === null || value === void 0 ? void 0 : value.includes(childItem.value));}).
      map((item) => item.value);

      setOpenGroups(groupsToExpand);
    }
  }, [items, value, startOnSelected]);

  useEffect(() => {
    setSearchTerm(search);
    setExternalSearch(search);
  }, [search]);

  useEffect(() => {
    if (externalSearch && searchTerm) {var _optionsRef$current, _optionsRef$current$q;
      (_optionsRef$current = optionsRef.current) === null || _optionsRef$current === void 0 ? void 0 : (_optionsRef$current$q = _optionsRef$current.querySelector('input')) === null || _optionsRef$current$q === void 0 ? void 0 : _optionsRef$current$q.focus();
    }
  }, [externalSearch, filteredItems, searchTerm]);

  useEffect(() => {
    if (value) {
      setSelectedItems(value);
    }
  }, [value]);

  useEffect(() => {
    let filtered = [...items];

    filtered = filtered.
    map((item) => {var _item$items2, _item$items3;
      const itemiSelected = selectedItems.includes(item.value) || item.suggested;
      const containsSelected = (_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.some(
        (childItem) => selectedItems.includes(childItem.value) || childItem.suggested
      );

      const matchesSearch =
      !searchTerm || item.searchLabel.toLowerCase().includes(searchTerm.toLowerCase());

      const containsChildrenMatchingSearch =
      !searchTerm || ((_item$items3 =
      item.items) === null || _item$items3 === void 0 ? void 0 : _item$items3.some((childItem) =>
      childItem.searchLabel.toLowerCase().includes(searchTerm.toLowerCase())
      ));

      if (showAll && !searchTerm) {
        return item;
      }

      if (!showAll && !searchTerm && (itemiSelected || containsSelected)) {var _item$items4;
        return _objectSpread(_objectSpread({},
        item), {}, {
          items: (_item$items4 = item.items) === null || _item$items4 === void 0 ? void 0 : _item$items4.filter(
            (childItem) => selectedItems.includes(childItem.value) || childItem.suggested
          ) });

      }

      if (searchTerm && (matchesSearch || containsChildrenMatchingSearch)) {var _item$items5;
        return _objectSpread(_objectSpread({},
        item), {}, {
          items: (_item$items5 = item.items) === null || _item$items5 === void 0 ? void 0 : _item$items5.filter((childItem) =>
          childItem.searchLabel.toLowerCase().includes(searchTerm.toLowerCase())
          ) });

      }

      return null;
    }).
    filter((item) => item);

    setFilteredItems(filtered);
  }, [items, searchTerm, showAll, selectedItems]);

  const handleSelect = (_value) => {
    let newValues;
    if (singleSelect) {
      newValues = selectedItems.includes(_value) ? [] : [_value];
    } else {
      newValues = selectedItems.includes(_value) ?
      selectedItems.filter((item) => item !== _value) :
      [...selectedItems, _value];
    }

    setSelectedItems(newValues);
    setExternalSearch('');
    if (onChange) onChange(newValues);
  };

  const handleSelectAll = () => {
    const allValues = [];

    items.forEach((item) => {var _item$items6;
      if ((_item$items6 = item.items) !== null && _item$items6 !== void 0 && _item$items6.length) {var _item$items7;
        (_item$items7 = item.items) === null || _item$items7 === void 0 ? void 0 : _item$items7.forEach((subItem) => allValues.push(subItem.value));
      } else {
        allValues.push(item.value);
      }
    });

    setSelectedItems(allValues);
    if (onChange) onChange(allValues);
  };

  const applyFilter = ({ target }) => {
    setShowAll(target.value === 'true');
  };

  const renderButtonItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }

    const selected = selectedItems.includes(item.value);
    const borderSyles = selected ?
    'border-sucess-200' :
    'border-transparent hover:border-primary-300';

    return (/*#__PURE__*/
      _jsx("li", { className: "mb-4" }, item.value, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: `w-full flex text-left p-2.5 border ${borderSyles} rounded-lg items-center`,
        onClick: () => handleSelect(item.value) }, void 0, /*#__PURE__*/

      _jsx("span", { className: "flex-1" }, void 0, item.label), /*#__PURE__*/
      _jsx("div", { className: "flex-1" }, void 0, /*#__PURE__*/
      _jsx(Pill, { className: "float-right", color: selected ? 'green' : 'primary' }, void 0,
      selected ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Selected") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Select")
      )
      )
      )
      ));

  };

  const renderCheckboxItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }
    const selected = selectedItems.includes(item.value);
    return (/*#__PURE__*/
      _jsx("li", {

        className: `mb-2 ${!selected && searchTerm && !showAll ? 'opacity-70' : ''}` }, item.value, /*#__PURE__*/

      _jsx(Checkbox, {
        name: item.value,
        label: item.label,
        checked: selected,
        onChange: () => handleSelect(item.value) }
      )
      ));

  };

  const handleGroupToggle = (groupKey) => {
    if (openGroups.includes(groupKey)) {
      setOpenGroups(openGroups.filter((group) => group !== groupKey));
    } else {
      setOpenGroups([...openGroups, groupKey]);
    }
  };

  const isGroupOpen = (groupKey) => openGroups.includes(groupKey);

  const renderItem = (item) =>
  checkboxes ? renderCheckboxItem(item) : renderButtonItem(item);

  const renderGroup = (group) => {var _group$items2;
    const isOpen = isGroupOpen(group.value);
    if (foldableGroups) {var _group$items;
      return (/*#__PURE__*/
        _jsx("li", { className: "mb-4" }, group.value, /*#__PURE__*/
        _jsx("div", {
          className: `flex justify-between p-3 mb-4 rounded-lg ${isOpen ? 'bg-indigo-50' : 'bg-gray-50'}`,
          onClick: () => handleGroupToggle(group.value) }, void 0, /*#__PURE__*/

        _jsx("span", { className: "block text-sm font-bold text-gray-900" }, void 0, group.label), /*#__PURE__*/
        _jsx("button", {
          className: "text-indigo-800 bg-indigo-200 rounded-[6px] text-xs font-medium px-1.5 py-0.5 flex flex-row items-center justify-center gap-1",
          type: "button" }, void 0, /*#__PURE__*/

        _jsx("div", { className: "w-3 h-3 text-sm" }, void 0,
        isOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {})
        ), /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Group")
        )
        ),
        isOpen && /*#__PURE__*/_jsx("ul", { className: "pl-4" }, void 0, (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(renderItem))
        ));

    }

    return (/*#__PURE__*/
      _jsx("li", { className: "mb-4" }, group.value, /*#__PURE__*/
      _jsx("span", { className: "block mb-4 text-sm font-bold text-gray-900" }, void 0, group.label), /*#__PURE__*/
      _jsx("ul", { className: "" }, void 0, (_group$items2 = group.items) === null || _group$items2 === void 0 ? void 0 : _group$items2.map(renderItem))
      ));

  };

  const renderSelectedLabel = () => {
    if (suggestions) {
      return (/*#__PURE__*/
        React.createElement(React.Fragment, null, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Selected or suggested"), ' ',
        selectedOrSuggestedItems.size ? `(${selectedOrSuggestedItems.size})` : ''
        ));

    }

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Selected"), " ", selectedItems.length ? `(${selectedItems.length})` : ''
      ));

  };

  return (/*#__PURE__*/
    _jsx("div", { className: `relative ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sticky top-0 w-full pt-4 mb-2 bg-white" }, void 0, /*#__PURE__*/
    _jsx(Label, { htmlFor: "search-multiselect", hideLabel: !label, hasErrors: Boolean(hasErrors) }, void 0,
    label
    ), /*#__PURE__*/
    _jsx(InputField, {
      id: "search-multiselect",
      label: "search-multiselect",
      hideLabel: true,
      onChange: (e) => setSearchTerm(e.target.value),
      placeholder: "Search",
      value: searchTerm,
      clearFieldAction: () => setSearchTerm('') }
    ), /*#__PURE__*/
    _jsx("div", { className: "flex mx-1 my-4 flex-nowrap" }, void 0, /*#__PURE__*/
    _jsx(RadioSelect, {
      name: "filter",
      orientation: "horizontal",
      options: [
      {
        label: /*#__PURE__*/_jsx(Translate, { "data-testid": "multiselectlist-show-all" }, void 0, "All"),
        value: 'true',
        defaultChecked: !startOnSelected
      },
      {
        label: renderSelectedLabel(),
        value: 'false',
        disabled: selectedOrSuggestedItems.size === 0,
        defaultChecked: startOnSelected
      }],

      onChange: applyFilter,
      className: "flex-grow" }
    ),
    allowSelelectAll && /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "text-gray-400 underline",
      onClick: () => handleSelectAll() }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Select all")
    )

    )
    ),

    items.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex w-full h-full items-center justify-center min-h-[300px]" }, void 0,
    renderChild(blankState)
    ), /*#__PURE__*/

    React.createElement("ul", { className: "w-full px-2 pt-2 grow", ref: optionsRef },
    filteredItems.map(renderItem)
    )
    ));

};
export { MultiselectList };